import { type FC, useState } from 'react';
import { ActionIcon, Box, Stack, Text, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import styles from './ErrorNotificationMessage.module.css';

type ErrorNotificationMessageProps = {
    message?: string;
    traceId?: string | null;
};

export const ErrorNotificationMessage: FC<ErrorNotificationMessageProps> = ({ message, traceId }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!traceId) {
            return;
        }

        try {
            await navigator.clipboard.writeText(traceId);
            setCopied(true);
            setTimeout(() => {
                return setCopied(false);
            }, 2000);
        } catch {}
    };

    return (
        <Stack
            className={styles.root}
            gap='xs'
        >
            {message && (
                <Text
                    size='sm'
                    c='dimmed'
                >
                    {message}
                </Text>
            )}

            {traceId && (
                <Box className={styles.traceRow}>
                    <Text
                        className={styles.traceLabel}
                        size='sm'
                        c='dimmed'
                    >
                        Код ошибки:
                    </Text>

                    <Text
                        className={styles.traceId}
                        size='sm'
                        fw={500}
                        title={traceId}
                    >
                        {traceId}
                    </Text>

                    <Tooltip
                        label={copied ? 'Скопировано' : 'Скопировать код ошибки'}
                        position='top'
                    >
                        <ActionIcon
                            className={styles.copyButton}
                            aria-label={copied ? 'Код ошибки скопирован' : 'Скопировать код ошибки'}
                            size='sm'
                            variant='subtle'
                            color={copied ? 'green' : 'gray'}
                            onClick={handleCopy}
                        >
                            {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
                        </ActionIcon>
                    </Tooltip>
                </Box>
            )}
        </Stack>
    );
};
